import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconAllChannels from './nav-icon-all-channels.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconAllChannels {...validProps} />;
}
SvgComponent.iconName = 'navIconAllChannels';

export const NavIconAllChannelsIcon = svgIconWrapper(SvgComponent);
